import { z } from 'zod';
import { paginationSchema } from './common.js';

/** Modelle, Kategorien, Hersteller, Standorte, Lieferanten, Statuswerte. */

export const namedEntitySchema = z.object({
  id: z.number().int(),
  name: z.string(),
  is_active: z.boolean(),
  assets_count: z.number().int().optional(),
  snipe_id: z.number().int().nullable(),
});

export const namedEntityCreateSchema = z.object({
  name: z.string().trim().min(1).max(160),
  is_active: z.boolean().default(true),
});

export const namedEntityUpdateSchema = namedEntityCreateSchema.partial();

export const modelSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  model_number: z.string().nullable(),
  category: z.object({ id: z.number().int(), name: z.string() }).nullable(),
  manufacturer: z.object({ id: z.number().int(), name: z.string() }).nullable(),
  assets_count: z.number().int().optional(),
  snipe_id: z.number().int().nullable(),
});
export type Model = z.infer<typeof modelSchema>;

export const modelCreateSchema = z.object({
  name: z.string().trim().min(1).max(200),
  category_id: z.number().int().positive(),
  manufacturer_id: z.number().int().positive().nullable().optional(),
  model_number: z.string().trim().max(120).nullable().optional(),
});

export const modelUpdateSchema = modelCreateSchema.partial();

export const modelListQuerySchema = paginationSchema.extend({
  q: z.string().trim().max(200).optional(),
  category_id: z.coerce.number().int().positive().optional(),
  manufacturer_id: z.coerce.number().int().positive().optional(),
  /** Modelle ohne Gerät ausblenden — 20 der 57 aus Snipe sind leer. */
  only_used: z.coerce.boolean().optional(),
});

export const statusSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  is_archived: z.boolean(),
  is_system: z.boolean(),
  sort_order: z.number().int(),
  assets_count: z.number().int().optional(),
});

/**
 * Die vier Statuswerte aus Snipe-IT. `key` ist der feste Bezug für die
 * Fachlogik — Namen dürfen umbenannt werden, Schlüssel nicht.
 */
export const SYSTEM_STATUSES = [
  { key: 'in_stock', name: 'Im Lager', is_archived: false, sort_order: 1 },
  { key: 'deployed', name: 'Ausgegeben', is_archived: false, sort_order: 2 },
  { key: 'sold', name: 'Mitarbeiterverkauf', is_archived: true, sort_order: 3 },
  { key: 'scrapped', name: 'Verschrottet', is_archived: true, sort_order: 4 },
] as const;

export type SystemStatusKey = (typeof SYSTEM_STATUSES)[number]['key'];
